import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/Utilize1.png'
import _imports_1 from '@/assets/images/Utilize2.png'


const _withScopeId = n => (_pushScopeId("data-v-78992b87"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content content-container" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "topImage",
  src: _imports_0,
  alt: "achieve"
}, null, -1))
const _hoisted_4 = { class: "sectionCol" }
const _hoisted_5 = { class: "topTitle" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "blocks" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "text" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"section\" data-v-78992b87><div class=\"sectionColBottom\" data-v-78992b87><p class=\"bottomTitle\" data-v-78992b87><span class=\"highlight\" data-v-78992b87>Achieve success with</span> Digital Cards Solutions Limited </p><p class=\"text\" data-v-78992b87> Don&#39;t miss your chance to excel </p></div><img class=\"imageBottom\" src=\"" + _imports_1 + "\" alt=\"achieve\" data-v-78992b87></div>", 1)

import VueScrollTo from 'vue-scrollto'
import { inject, reactive } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'UtilizeMobile',
  setup(__props) {

const scrollTo = VueScrollTo.scrollTo

const data = reactive({
  title: 'We utilize advanced targeting methods to maximize the number of followers and leads for your business',
  description: 'Our solutions are data-driven, and we constantly monitor and analyze results to improve our strategy and achieve the best possible outcomes for your business. Trust us to evaluate, plan, and execute result-driven campaigns seamlessly.',
  blocks: [
    { image: '1', text: 'Web Design' },
    { image: '2', text: 'Social Media' },
    { image: '3', text: 'Media Buying' },
    { image: '4', text: 'Marketing Strategies' }
  ]
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(data.title), 1),
        _createElementVNode("p", _hoisted_6, _toDisplayString(data.description), 1),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.blocks, (item, key) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `option-${key}`,
              class: "block"
            }, [
              _createElementVNode("img", {
                class: "icon",
                src: require(`@/assets/images/svg/utilize/${item.image}.svg`),
                alt: "icon"
              }, null, 8, _hoisted_8),
              _createElementVNode("p", _hoisted_9, _toDisplayString(item.text), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _hoisted_10
  ]))
}
}

})